"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = exports.getHighResolutionTime = exports.getLowResolutionTime = exports.getTime = exports.getBrowserTime = exports.supportsHighResolutionTime = void 0;
const Time_1 = require("./Time");
const SemanticMetrics_1 = require("../SemanticMetrics");
exports.supportsHighResolutionTime = () => {
    return process && typeof process.hrtime === 'function';
};
exports.getBrowserTime = () => {
    return typeof performance !== 'undefined' ? performance.now() : Date.now();
};
exports.getTime = () => {
    return exports.supportsHighResolutionTime() ? process.hrtime() : exports.getBrowserTime();
};
exports.getLowResolutionTime = (startTime) => {
    const millis = exports.getTime() - startTime;
    const time = Time_1.Time.fromMillis(millis);
    return {
        nanoseconds: SemanticMetrics_1.asNanoseconds(time.asNanos()),
        milliseconds: time.asMillis(),
        seconds: time.asSeconds(),
    };
};
exports.getHighResolutionTime = (startTime) => {
    const [diffSeconds, diffNanoseconds] = process.hrtime(startTime);
    const nanoseconds = diffSeconds * 1e9 + diffNanoseconds;
    const milliseconds = nanoseconds / 1e6;
    const seconds = nanoseconds / 1e9;
    return {
        nanoseconds: SemanticMetrics_1.asNanoseconds(nanoseconds),
        milliseconds,
        seconds,
    };
};
class Timer {
    constructor(startTime) {
        this.startTime = startTime;
    }
    static start() {
        return new Timer(exports.getTime());
    }
    end() {
        if (exports.supportsHighResolutionTime()) {
            return exports.getHighResolutionTime(this.startTime);
        }
        return exports.getLowResolutionTime(this.startTime);
    }
}
exports.Timer = Timer;
//# sourceMappingURL=Timer.js.map